import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../../components/accordion'
import { GroupEvent } from '../../group_event'


export const GroupEventPanel = ({ isLocked, ...props }) => (
  <AccordionPanel
    titleId="group-event-label"
    title={I18n.t('publisher.event_types.group.invitee_limit.label')}
    subheader={<Summary />}
    {...props}
  >
    <GroupEvent isLocked={isLocked} />
  </AccordionPanel>
)
